import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/Layout'

const InfoSec = () => {
  const {
    site: {
      siteMetadata: { title },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Layout>
      <Helmet>
        <html className="template" lang="ja" />
        <title>{`情報セキュリティ基本方針 | ${title}`}</title>
      </Helmet>
      <div className="common-header clearfix">
        <h1>情報セキュリティ基本方針</h1>
        <div className="breadcrumb">
          <li>
            <Link to={`/`}>トップページ</Link>
          </li>
          /<li>情報セキュリティ基本方針</li>
        </div>
      </div>

      <div className="main-wrapper">
        <div className="row">
          <div className="container">
            <h2>基本理念</h2>
            <br />
            株式会社アイテック（以下、当社）は、「駐車場設備機器の製造・販売・設置ならびに時間貸駐車場の運営・管理・集金代行のサービス」を提供する事業体として、当社の事業の中で取り扱うお客様の貴重な情報をはじめとする情報資産は、当社の経営基盤として極めて重要なものです。
            <br />
            <br />
            当社は、漏洩、き損、滅失等のリスクからこれら情報資産を保護することの重要性を認識し、役員、従業員以下、すべての従業者を挙げて本方針を遵守し、情報資産の機密性、完全性、可用性といった情報セキュリティを維持するための活動を実践いたします。
            <br />
            <br />
            <br />
            <h2>基本方針</h2>
            <br />
            １．情報資産を保護するために、情報セキュリティポリシーを策定し、これに従って業務を行うとともに、情報セキュリティに関連する法令、規制その他の規範、及び、お客様との契約事項を遵守いたします。
            <br />
            <br />
            ２．情報資産に対して存在する漏洩、き損、滅失等のリスクを分析、評価するための基準を明確にし、体系的なリスクアセスメント方法を確立するとともに、定期的にリスクアセスメントを実施いたします。また、その結果に基づき、必要かつ適切なセキュリティ対策を実施いたします。
            <br />
            <br />
            ３．担当役員を中心とした情報セキュリティ体制を確立するとともに、情報セキュリティに関する権限および責任を明確にいたします。また、すべての従業者が、情報セキュリティの重要性を認識し、情報資産の適切な取り扱いを確実にするために、定期的に教育、訓練および啓発を行います。
            <br />
            <br />
            ４．情報セキュリティポリシーの遵守状況及び情報資産の取扱いについて、定期的に点検及び監査を行い、発見された不備や改善項目については、速やかに是正処置を講じます。
            <br />
            <br />
            ５．情報セキュリティ上のイベントやインシデントの発生に対する適切な処置を講じるとともに、万一それらが発生した場合に際して、あらかじめ、被害を最小限に留めるための対応手順を確立し、有事の際には、速やかに対応するとともに、適切な是正処置を講じます。また、特に、業務中断に関わるようなインシデントについては、その管理の枠組みを確立し、定期的に対応、復旧試験及び見直しを行うことにより、当社の事業継続を確実にいたします。
            <br />
            <br />
            ６．基本理念を実現するための目標を定めた情報セキュリティマネジメントシステムを確立し、これを実行するとともに、継続的に見直し、改善を行います。
            <br />
            <br />
            <br />
            制定日：2025年10月1日
            <br />
            <br />
            株式会社アイテック
            <br />
            代表取締役　前川 卓志
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default InfoSec
